export const FEATURE_FLAGS = {
  login: true,
  collections: true,
  topics: true,
};
